// extracted by mini-css-extract-plugin
export default {"snsShare":"snsShare--xgILf","button":"button--ixzKm"};